import { Link } from "react-router-dom";
import { ArrowRight, MapPin, Clock } from "@phosphor-icons/react";
import { NGN } from "@/lib/api";
import { Badge } from "@/components/ui/badge";

export function OpportunityCard({ opp }) {
  const catLabel = {
    real_estate: "Real Estate", agriculture: "Agriculture",
    strategic: "Strategic", circle: "Investment Circle",
  }[opp.category] || opp.category;

  return (
    <div className="card-lift bg-white border border-slate-200 rounded-2xl overflow-hidden flex flex-col" data-testid={`opp-card-${opp.id}`}>
      <div className="relative aspect-[4/3] overflow-hidden bg-slate-100">
        {opp.image_url && (
          <img src={opp.image_url} alt={opp.name} className="h-full w-full object-cover transition-transform duration-500 hover:scale-105" />
        )}
        <div className="absolute top-3 left-3 flex gap-2">
          <Badge className="bg-white/95 text-[#0a1128] hover:bg-white shadow-sm font-medium">{catLabel}</Badge>
          <Badge className={`shadow-sm ${opp.status === "open" ? "bg-[#00b4d8] text-white hover:bg-[#0096c7]" : "bg-slate-800 text-white"}`}>{opp.status.toUpperCase()}</Badge>
        </div>
      </div>
      <div className="p-6 flex flex-col flex-1">
        <h3 className="font-display font-bold text-xl text-[#0a1128] leading-tight">{opp.name}</h3>
        <p className="mt-2 text-sm text-slate-600 line-clamp-2">{opp.description}</p>

        <div className="mt-5 grid grid-cols-2 gap-3 text-sm">
          <div>
            <p className="text-slate-500 text-xs">Minimum</p>
            <p className="font-semibold text-[#0a1128]">{NGN(opp.minimum_investment)}</p>
          </div>
          <div>
            <p className="text-slate-500 text-xs">Duration</p>
            <p className="font-semibold text-[#0a1128] flex items-center gap-1"><Clock size={14} />{opp.duration}</p>
          </div>
        </div>

        <div className="mt-5 pt-5 border-t border-slate-100 flex items-center justify-between">
          <Link to={`/investments/${opp.id}`} data-testid={`opp-view-${opp.id}`} className="text-sm font-semibold text-[#00b4d8] hover:text-[#0096c7] inline-flex items-center gap-1">
            View Details <ArrowRight size={14} />
          </Link>
          <Link to={`/investments/${opp.id}`} data-testid={`opp-invest-${opp.id}`} className="text-sm font-semibold bg-[#0a1128] text-white px-4 py-2 rounded-full hover:bg-[#071026] transition-colors">
            Invest Now
          </Link>
        </div>
      </div>
    </div>
  );
}

export function ProjectCard({ p }) {
  return (
    <div className="card-lift bg-white border border-slate-200 rounded-2xl overflow-hidden" data-testid={`project-card-${p.id}`}>
      {p.image_url && (
        <div className="aspect-video overflow-hidden bg-slate-100">
          <img src={p.image_url} alt={p.name} className="h-full w-full object-cover transition-transform duration-500 hover:scale-105" />
        </div>
      )}
      <div className="p-6">
        <p className="text-xs font-bold tracking-[0.2em] text-[#00b4d8]">{(p.subcategory || p.sector).toUpperCase()}</p>
        <h3 className="mt-2 font-display font-bold text-xl text-[#0a1128]">{p.name}</h3>
        <p className="mt-1 text-sm text-slate-500 flex items-center gap-1"><MapPin size={14} />{p.location}</p>
        <p className="mt-3 text-sm text-slate-600 line-clamp-2">{p.description}</p>
        <div className="mt-4 grid grid-cols-2 gap-3 text-sm">
          <div><p className="text-slate-500 text-xs">Requirement</p><p className="font-semibold">{p.investment_requirement}</p></div>
          <div><p className="text-slate-500 text-xs">Timeline</p><p className="font-semibold">{p.timeline}</p></div>
        </div>
        <details className="mt-4">
          <summary className="text-sm font-semibold text-[#00b4d8] cursor-pointer">View return & risk information</summary>
          <div className="mt-3 space-y-2 text-sm text-slate-600">
            <p><span className="font-semibold text-[#0a1128]">Expected Return:</span> {p.expected_return}</p>
            <p><span className="font-semibold text-[#0a1128]">Risk:</span> {p.risk_information}</p>
            {p.investment_terms && <p><span className="font-semibold text-[#0a1128]">Terms:</span> {p.investment_terms}</p>}
          </div>
        </details>
      </div>
    </div>
  );
}
